import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { AbstractTuiPortalService, AbstractTuiPortalHostComponent } from '@taiga-ui/cdk/abstract';

/**
 * Service for displaying dropdown portals
 */
class TuiDropdownPortalService extends AbstractTuiPortalService {
}
TuiDropdownPortalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiDropdownPortalService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
TuiDropdownPortalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiDropdownPortalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiDropdownPortalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/**
 * Host element for dynamically created portals, for example using {@link TuiDropdownDirective}.
 */
class TuiDropdownHostComponent extends AbstractTuiPortalHostComponent {
}
TuiDropdownHostComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiDropdownHostComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
TuiDropdownHostComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TuiDropdownHostComponent, selector: "tui-dropdown-host", providers: [
        { provide: AbstractTuiPortalService, useExisting: TuiDropdownPortalService },
        // TODO: Remove in 4.0
        { provide: AbstractTuiPortalHostComponent, useExisting: TuiDropdownHostComponent },
    ], usesInheritance: true, ngImport: i0, template: "<ng-content></ng-content>\n<ng-container #viewContainer></ng-container>\n", styles: [":host{position:relative;z-index:0;display:block;height:100%}:host:before{content:\"\";display:block;overflow:hidden}.t-position-fixed-offset{position:fixed;left:0;top:0;pointer-events:none;visibility:hidden;width:100%;height:100%}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiDropdownHostComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'tui-dropdown-host',
                    templateUrl: './dropdown-host.template.html',
                    styleUrls: ['./dropdown-host.style.less'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        { provide: AbstractTuiPortalService, useExisting: TuiDropdownPortalService },
                        // TODO: Remove in 4.0
                        { provide: AbstractTuiPortalHostComponent, useExisting: TuiDropdownHostComponent },
                    ],
                }]
        }] });

class TuiDropdownHostModule {
}
TuiDropdownHostModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiDropdownHostModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiDropdownHostModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiDropdownHostModule, declarations: [TuiDropdownHostComponent], exports: [TuiDropdownHostComponent] });
TuiDropdownHostModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiDropdownHostModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiDropdownHostModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TuiDropdownHostComponent],
                    exports: [TuiDropdownHostComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiDropdownHostComponent, TuiDropdownHostModule, TuiDropdownPortalService };
